import classNames from "classnames"
import { Icon } from "web/components"

export default function Tabs({ tabs, selectedTabKey, onTabSelect }) {
  return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          onChange={(event) => onTabSelect(event.target.value.toLowerCase())}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => onTabSelect(tab.key)}
                className={classNames(
                  "flex cursor-pointer whitespace-nowrap border-b-2 border-transparent px-1 py-4 text-sm font-medium hover:border-gray-200 hover:text-gray-700",
                  {
                    "border-blue-200 text-blue-600 text-gray-500":
                      tab.key === selectedTabKey && !tab.hasErrors,
                    "text-red-500": tab.hasErrors,
                    "border-red-200 text-red-900":
                      tab.key === selectedTabKey && tab.hasErrors,
                  }
                )}
                aria-current={tab.key === selectedTabKey ? "page" : undefined}
              >
                {tab.name}
                {tab.hasErrors ? (
                  <span
                    className={classNames(
                      tab.key === selectedTabKey
                        ? "bg-red-100 text-red-600"
                        : "bg-red-100 text-red-900",
                      "ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
                    )}
                  >
                    {tab.errorCount}
                  </span>
                ) : (
                  <span
                    className={classNames(
                      tab.key === selectedTabKey
                        ? "bg-indigo-100 text-indigo-600"
                        : "bg-gray-100 text-gray-900",
                      "ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
                    )}
                  >
                    {tab.count}
                  </span>
                )}

                {tab.status === "applied" && (
                  <Icon
                    name="check-circle"
                    className="ml-3 h-5 w-5 text-green-400"
                  />
                )}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}
